<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col"> Uniform Details</div>
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" name="Viewuniform" (click)="Excel()">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="card-body" style="overflow: auto; height: 450px;">
        <div class="row">
            <div class="col-md mx-1 px-1 bghighlight">
                <label class="text-label">Employee</label><br />
                <label class="Label1">
                    <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                        <div class="col-2">
                            <img *ngIf="InputData.Photo != null && InputData.Photo != ''" mat-card-image
                                class="userImage" [src]="common.PhotoLink(InputData.Photo)" />
                            <div *ngIf="InputData.Photo == null || InputData.Photo == ''" class="initial-image">
                                <div class="image">
                                    {{common.getInitial(InputData.EmpName)}}
                                </div>
                            </div>
                        </div>
                        <div class="col-9 userdetail">
                            <span class="text-label">{{InputData.EmpName}}</span><br />
                            <span class="text-label-light">#{{InputData.EmpCode}}</span><br />
                            <span class="text-label-light">{{InputData.DesignationName}}</span>
                        </div>
                    </div>
                </label>
            </div>
        </div>
        <div class="card border-radius-0 mt-1 p-0">
            <div class="card-header">
                Data
            </div>
            <div class="card-body p-1" style="overflow: auto;">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" style="width: 5px;">View</th>
                            <th scope="col">Document No</th>
                            <th scope="col">Issue Date</th>
                            <th scope="col">Branch</th>
                            <th scope="col">Issue Type</th>
                            <th scope="col">Item Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let site of UniformDetails; let i = index"> 
                            <td style="width: 5px;">
                                <div class="text-center">
                                    <i (click)="ViewDocument(site)" class="bi bi-eye cursor-pointer fw-bold"></i>
                                </div>
                            </td>       
                            <td>{{ site['DocumentNo'] }}</td>
                            <td>{{ site['IssueDate'] }}</td>
                            <td>{{ site['Branch'] }}</td>
                            <td>{{ site['IssueType'] }}</td>
                            <td>{{ site['ItemCount'] }}</td>    
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="Cancel()"
                    autofocus="true" #cancelButton id="cancelButton">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>